import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _dec, _dec2, _dec3, _obj;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import { LMClick } from '@utils/LMEvent';
import webLogin from '@utils/weblogin';
import videoService from '@services/videoService';
import Preloader from '@utils/preloader';
import VideoPlayer from '../../../../../basic/video-player';
import Profile from './Profile';
import MessageBox from './MessageBox';
import Toolbar from './Toolbar';
import Chatter from './Chatter';
import Toast from '../../../../../basic/toast/live';
import TopGifters from './TopGifters';
import personalCard from './personalCard/card';
import Tooltip from './Tooltip';
import FollowModal from './FollowModal';
import Intercept from '@ui/packages/pcv2/pages/page-live/src/mixins/Intercept';
export default {
  name: 'Liveroom',
  mixins: [Intercept],
  components: {
    videoplayer: VideoPlayer,
    profile: Profile,
    'message-box': MessageBox,
    toolbar: Toolbar,
    chatter: Chatter,
    toast: Toast,
    tooltip: Tooltip,
    'top-gifters': TopGifters,
    'follow-modal': FollowModal,
    personalcard: personalCard
  },
  props: {
    authentication: Object,
    wallet: Object,
    channel: [String, Object],
    minimum: Boolean
  },
  data: function data() {
    return {
      playState: true,
      VideoAPIService: null,
      // / 媒体
      mediaSource: '',
      mediaPoster: '',
      mediaOptions: {
        autoHide: true,
        autoplay: true,
        anywayAutoplay: false,
        controlsList: ['nogradient', 'nodanmakuswitch', 'notimedisplay', 'nodurationdisplay', 'noprogress', 'noratepicker', 'nodanmaku', 'noprofiler', 'notoprightbar', 'nonextbutton', 'nopipbutton', 'nowindowbutton'],
        fitmode: 'contain',
        animation: {
          giftbarMaxCount: 2,
          giftbarAlignToBottom: false,
          giftbarTopMargin: 20,
          giftbarLeftMargin: 20,
          displayVideoAnimation: true
        }
      },
      // / 频道
      channelID: '',
      channelInitTimestamp: 0,
      anchorID: '',
      anchorName: '',
      anchorPortrait: '',
      anchorLevel: 1,
      heatCount: 0,
      chatSystem: '',
      title: '',
      completed: false,
      deleted: false,
      // / 信令
      socket: null,
      // / 礼物墙
      isOpenGiftWall: false,
      giftTabs: [],
      giftList: [],
      gradeList: [],
      // / 生命周期。
      isComponentDestroyed: false,
      isDispatchInitMessage: false,
      // / 下载器。
      preloader: null,
      // / toast 提示。
      toastMessage: '',
      toastVisible: false,
      // / 关注邀请函。
      followInvitationHandle: 0,
      followInvitationInterval: 30 * 1000,
      // / 引导提示。
      showFollowTooltipDelay: 15 * 1000,
      showFollowTooltipDelayHandle: 0,
      showFollowTooltipMaxTimesPerDay: 3,
      showFollowTooltipVisible: false,
      showGiftWallTooltipDelay: 0,
      showGiftWallTooltipDelayHandle: 0,
      showGiftWallTooltipMaxTimes: 1,
      showGiftWallTooltipVisible: false,
      showShareTooltipDelay: 15 * 1000,
      showShareTooltipDelayHandle: 0,
      showShareTooltipVisible: false,
      // / 关闭页面引导。
      showFollowModalTimes: 0,
      showFollowModalVisible: false,
      showFollowModalAfter: 50 * 1000,
      showFollowModalMaxTimesPerDay: 3,
      showShareMaxTimesPerDay: 3,
      showShareTimeTooltipDelayHandle: 0,
      // / 是否显示个人卡片
      isShowCard: false,
      cardTargetUid: '',
      cardType: 0,
      cardTop: '0',
      cardLeft: '0',
      // / 礼物榜。
      topGiftersReloadInterval: 5000,
      topGiftersReloadHandle: 0,
      topGidtersReloadTimestamp: 0,
      // webrtc
      // webrtcEnvironment: "prod", // test | prod | dev
      // webrtcAppId: "5291372290",
      // webrtcAppSecret: "f5e9cfc87f7d9c41e8b495419e315bc0",
      webrtcEnabled: true,
      webrtcSupported: typeof OctopusRTC !== 'undefined' && OctopusRTC.isSupported(),
      webrtcUserId: '',
      webrtcUserName: '',
      webrtcRoomId: '',
      webrtcAppId: '',
      webrtcAppSecret: '',
      webrtcImpl: null,
      webrtcImplName: '',
      webrtcStreamList: []
    };
  },
  computed: {
    channelDependencies: function channelDependencies() {
      return {
        authentication: webLogin.getAuthentication(),
        channel: this.channel
      };
    },
    locale: function locale() {
      return util.getI18nLocale();
    },
    isShowGiftWall: function isShowGiftWall() {
      if (!this.authentication) {
        return true;
      }
      // 主播id this.anchorID 
      // 用户id this.authentication.uid
      return this.authentication && this.authentication.uid !== this.anchorID;
    }
  },
  created: function created() {
    this.VideoAPIService = videoService.createApi();
    // this.updateChannel();
    this.initPreloader();
    // try{
    //     // / 点击任意位置礼物面板关闭。
    //     const callback = (e) => {
    //         if(e&&e.target){
    //             const a=e.target.className.indexOf('gift');
    //             const b=e.target.parentElement.className.indexOf('gift');
    //             const c=e.target.parentElement.parentElement.className.indexOf('gift');
    //             if(a==-1&&b==-1&&c==-1){
    //                 this.isOpenGiftWall = false;
    //             }
    //         }
    //     };
    //     document.addEventListener('click', callback, true);
    //  } catch (e) {}
  },
  beforeDestroy: function beforeDestroy() {
    this.isComponentDestroyed = true;
    clearTimeout(this.followInvitationHandle);
    clearTimeout(this.topGiftersReloadHandle);
    this.clearTooltips();
    if (this.socket) {
      this.socket.unInitCmIm();
      this.socket = null;
      this.dispatchLeaveLiveroomMessage();
    }
  },
  // inject: ['getNuxtContext'],
  methods: (_dec = LMClick('Live-Room'), _dec2 = LMClick('Live-Room'), _dec3 = LMClick('Live-Room'), _obj = {
    // async fetchLiveQueryInfo(channel, locale, authentication) {
    //   const { videoInfoData } = typeof this.getNuxtContext === 'function' ? this.getNuxtContext() : {};
    //     if (videoInfoData) {
    //         return videoInfoData;
    //     }
    //     // 获取 直播间信息
    //     const res = await this.VideoAPIService.joinChannel(channel, locale, authentication || {});
    //     return res;
    // },
    destroyCurrent: function destroyCurrent() {
      clearTimeout(this.followInvitationHandle);
      clearTimeout(this.topGiftersReloadHandle);
      this.clearTooltips();
      this.clearMessage();
      if (this.socket) {
        this.socket.unInitCmIm();
        this.socket = null;
        this.dispatchLeaveLiveroomMessage();
      }
      /**
       * 销毁webRTC
       */
      this.destroyWebRTC();
      this.mediaSource = '';
      this.mediaPoster = '';
    },
    destroyComplete: function destroyComplete() {
      if (this.socket) {
        this.socket.unInitCmIm();
        this.socket = null;
        this.dispatchLeaveLiveroomMessage();
      }
      /**
       * 销毁webRTC
       */
      this.destroyWebRTC();
      this.mediaSource = '';
    },
    destroyWebRTC: function destroyWebRTC() {
      if (this.webrtcImpl === null) {
        return;
      }
      if (this.webrtcImplName === 'octopus') {
        this.webrtcImpl.off('stream-update', this.onOctopusStreamUpdate);
        this.webrtcImpl.off('disconnect', this.onOctopusDisconnect);
        this.webrtcImpl.off('kick-out', this.onOctopusKickout);
        this.stopPlayingOctopusSteam(this.webrtcStreamList);
        this.webrtcStreamList = [];
        this.webrtcImpl.logout();
        this.webrtcImpl = null;
      }
    },
    initPreloader: function initPreloader() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.preloader = Preloader;
              _this.preloader.updateStickerList();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateChannel: function updateChannel() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var forceCDNStream, channel;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              forceCDNStream = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              if (_this2.channel) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _this2.destroyCurrent();
              if (!(typeof _this2.channel === 'string')) {
                _context2.next = 10;
                break;
              }
              _context2.next = 7;
              return _this2.fetchLiveQueryInfo(_this2.channel, _this2.locale, _this2.authentication || {});
            case 7:
              channel = _context2.sent.video_info;
              _context2.next = 11;
              break;
            case 10:
              channel = JSON.parse(JSON.stringify(_this2.channel));
            case 11:
              if (!(!channel || !channel.vid || _this2.isComponentDestroyed)) {
                _context2.next = 13;
                break;
              }
              return _context2.abrupt("return");
            case 13:
              console.log('channel:', channel);
              _this2.logStreamView(channel.userid, channel.vid);
              _this2.channelID = channel.vid;
              _this2.channelInitTimestamp = Date.now();
              _this2.anchorID = channel.userid;
              _this2.anchorName = channel.uname;
              _this2.anchorPortrait = channel.uface;
              _this2.anchorLevel = +channel.level;
              _this2.chatSystem = channel.chatSystem;
              _this2.heatCount = +(channel.heat || 0);
              _this2.title = channel.title;
              _this2.mediaPoster = channel.videocapture;
              /**
               * 直播已删除
               */
              if (!(channel.status === '2')) {
                _context2.next = 28;
                break;
              }
              _this2.deleted = true;
              return _context2.abrupt("return");
            case 28:
              _context2.next = 30;
              return _this2.createMediaSource(channel, forceCDNStream);
            case 30:
              _this2.mediaSource = _context2.sent;
              if (!(!channel.videosource && !channel.hlsvideosource)) {
                _context2.next = 34;
                break;
              }
              /**
               * 如果没有直播资源直接设置为播放完成
               * 停止向下执行
               */
              _this2.completed = true;
              return _context2.abrupt("return");
            case 34:
              if (!(channel.status !== '0')) {
                _context2.next = 42;
                break;
              }
              _this2.playState = false;
              _this2.$refs.player.removeControl('noprogress');
              _this2.completed = true;
              setTimeout(function () {
                _this2.completed = false;
              }, 5000);
              return _context2.abrupt("return");
            case 42:
              _this2.playState = true;
              _this2.$refs.player.addControl('noprogress');
              _this2.updateGiftWall();
            case 45:
              _this2.completed = false;
              _this2.updateSingaling();
              _this2.initTooltips();
              _this2.initTimeInterval();
            case 49:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    createMediaSource: function createMediaSource(channel) {
      var _arguments2 = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var forceCDNStream, webrtcMediaSources;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              forceCDNStream = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : false;
              if (!(!forceCDNStream && +channel.vtype !== 8)) {
                _context3.next = 13;
                break;
              }
              _context3.prev = 2;
              _context3.next = 5;
              return _this3.initWebRTC(channel);
            case 5:
              webrtcMediaSources = _context3.sent;
              if (!webrtcMediaSources) {
                _context3.next = 8;
                break;
              }
              return _context3.abrupt("return", webrtcMediaSources);
            case 8:
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](2);
              console.log('init webrtc error:', _context3.t0);
            case 13:
              return _context3.abrupt("return", [util.addQueryStringParameter(util.forceHttps(channel.hlsvideosource || ''), 'lhls', '1'), util.forceHttps(channel.videosource || '')]);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 10]]);
      }))();
    },
    initWebRTC: function initWebRTC(channel) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              console.log('webrtcEnabled:', _this4.webrtcEnabled);
              console.log('webrtcSupported:', _this4.webrtcSupported);
              console.log('webrtcForceMode:', _this4.webrtcForceMode);
              if (!(_this4.webrtcEnabled && (_this4.webrtcForceMode || _this4.webrtcSupported))) {
                _context4.next = 8;
                break;
              }
              _this4.webrtcImplName = channel.isTCLine === '3' ? 'octopus' : channel.isTCLine === '4' ? 'zego' : 'other';
              console.log('webrtcImplName:', _this4.webrtcImplName);
              if (!(_this4.webrtcImplName === 'octopus')) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", _this4.initOctopusWebRTC(channel));
            case 8:
              return _context4.abrupt("return", null);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    initOctopusWebRTC: function initOctopusWebRTC(channel) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$_this5$getOcto, app_id, auth, expire_ts;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.webrtcUserId = _this5.isAuthenticated(_this5.authentication) ? _this5.authentication.uid : '' + Date.now();
              _this5.webrtcUserName = "u".concat(_this5.webrtcUserId);
              _this5.webrtcRoomId = channel.vid;
              console.log('webrtcUserId:', _this5.webrtcUserId);
              console.log('webrtcUserName:', _this5.webrtcUserName);
              console.log('webrtcRoomId:', _this5.webrtcRoomId);
              _context5.next = 8;
              return _this5.getOctopusAuthInfo();
            case 8:
              _yield$_this5$getOcto = _context5.sent;
              app_id = _yield$_this5$getOcto.app_id;
              auth = _yield$_this5$getOcto.auth;
              expire_ts = _yield$_this5$getOcto.expire_ts;
              console.log('auth:', app_id, auth, expire_ts);
              _this5.webrtcAppId = app_id;
              _this5.webrtcImpl = new OctopusRTC({
                appId: _this5.webrtcAppId,
                userId: _this5.webrtcUserId,
                userName: _this5.webrtcUserName
              });
              _this5.webrtcImpl.init();
              _this5.webrtcImpl.on('stream-update', _this5.onOctopusStreamUpdate);
              _this5.webrtcImpl.on('disconnect', _this5.onOctopusDisconnect);
              _this5.webrtcImpl.on('kick-out', _this5.onOctopusKickout);
              _context5.next = 21;
              return _this5.webrtcImpl.login(_this5.webrtcRoomId, 2, auth, expire_ts);
            case 21:
              _this5.webrtcStreamList = _context5.sent;
              console.log('webrtcStreamList:', _this5.webrtcStreamList);
              _this5.$lmBus && _this5.$lmBus.$emit('Live-Play-Success-Handle');
              if (!(_this5.webrtcStreamList.length !== 1)) {
                _context5.next = 26;
                break;
              }
              return _context5.abrupt("return", null);
            case 26:
              return _context5.abrupt("return", _this5.startPlayingOctopusStream(_this5.webrtcStreamList));
            case 27:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    onOctopusStreamUpdate: function onOctopusStreamUpdate(_ref) {
      var code = _ref.code,
        streamList = _ref.streamList;
      console.log('webrtc stream update', code, streamList);
      if (code === 1) {
        // 切换成多路流。
        this.updateChannel(true); // 切换成 m3u8 模式。
      }
    },
    onOctopusDisconnect: function onOctopusDisconnect() {
      console.log('webrtc disconnect');
      this.destroyWebRTC();
    },
    onOctopusKickout: function onOctopusKickout() {
      console.log('webrtc kickout');
      this.destroyWebRTC();
    },
    startPlayingOctopusStream: function startPlayingOctopusStream(streamList) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var mediaSources, _iterator, _step, streamInfo, mediaStream;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              mediaSources = [];
              _iterator = _createForOfIteratorHelper(streamList);
              _context6.prev = 2;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context6.next = 13;
                break;
              }
              streamInfo = _step.value;
              _context6.next = 8;
              return _this6.webrtcImpl.startPlayingStream(streamInfo.streamId);
            case 8:
              mediaStream = _context6.sent;
              mediaSources.push({
                url: mediaStream,
                type: "application/webrtc-media-stream",
                identifier: mediaSources.length,
                isPrimary: mediaSources.length === 0
              });
              util.KEWLSensorTrack({
                lmweb_clickText: '播放WEBRTC流',
                lmweb_tabName: 'pc'
              });
            case 11:
              _context6.next = 4;
              break;
            case 13:
              _context6.next = 18;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](2);
              _iterator.e(_context6.t0);
            case 18:
              _context6.prev = 18;
              _iterator.f();
              return _context6.finish(18);
            case 21:
              return _context6.abrupt("return", mediaSources);
            case 22:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[2, 15, 18, 21]]);
      }))();
    },
    stopPlayingOctopusSteam: function stopPlayingOctopusSteam(streamList) {
      var _iterator2 = _createForOfIteratorHelper(streamList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var streamInfo = _step2.value;
          this.webrtcImpl.stopPlayingStream(streamInfo.streamId);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    getOctopusAuthInfo: function getOctopusAuthInfo() {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return window.KEWLHttp("https://live.liveme.com/open/v0/getAuth");
            case 2:
              response = _context7.sent;
              if (!(+response.data.status !== 200)) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return", Promise.reject(response.data));
            case 5:
              return _context7.abrupt("return", response.data.data);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    updateSingaling: function updateSingaling() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(!_this7.channelID || _this7.chatSystem !== '3')) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              if (_this7.socket) {
                _this7.socket.unInitCmIm();
                _this7.clearMessage();
              }
              _this7.socket = window['cmim'].create({
                loginInfo: {
                  user: _this7.isAuthenticated(webLogin.getAuthentication()),
                  uid: _this7.isAuthenticated(webLogin.getAuthentication()) ? webLogin.getAuthentication().uid : ''
                },
                urls: util.getImInfo(),
                roomId: _this7.channelID,
                joinRoomCallback: _this7.dispatchInitMessage.bind(_this7),
                recvMsgCallback: _this7.dispatchCustomMessagePacketObject.bind(_this7)
              });
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    updateGiftWall: function updateGiftWall() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var giftWall, giftTabs, list, i, temp, j, type, finanType, _i;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (_this8.channelID) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _context9.next = 4;
              return _this8.VideoAPIService.getGiftWall(_this8.channelID);
            case 4:
              giftWall = _context9.sent;
              giftTabs = giftWall.dataList;
              list = []; // eslint-disable-next-line no-plusplus
              for (i = 0; i < giftTabs.length; i++) {
                list.push(giftTabs[i]);
                temp = []; // eslint-disable-next-line no-plusplus
                for (j = 0; j < giftTabs[i].giftList.length; j++) {
                  type = giftTabs[i].giftList[j].animationType;
                  finanType = giftTabs[i].giftList[j].finanType;
                  /**
                   * 屏蔽特殊类型礼物 
                   * 7500你画我猜礼物
                   * 7600特权礼物
                   * 100 新手礼物
                   * finanType：101-金币；102-星光
                   */
                  if (type !== '7500' && type !== '7600' && type !== '100' && finanType != '102') {
                    temp.push(giftTabs[i].giftList[j]);
                  }
                }
                list[i].giftList = temp;
              }
              _this8.giftTabs = [];
              // eslint-disable-next-line no-plusplus
              for (_i = 0; _i < list.length; _i++) {
                if (list[_i].giftList.length > 0) {
                  _this8.giftTabs.push(list[_i]);
                }
              }
              _this8.giftList = _this8.getGiftList(giftWall.dataList);
              _this8.gradeList = giftWall.gradeList;
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    updateWalletSync: function updateWalletSync(value) {
      if (this.$refs.toolbar && this.$refs.toolbar.authorization) {
        this.$refs.toolbar.authorization.updateWalletSync(value);
      }
    },
    sendGiftMessage: function sendGiftMessage(giftID, count, finanType) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var result;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (webLogin.checkLogin()) {
                _context10.next = 3;
                break;
              }
              _this9.authenticateHandler();
              return _context10.abrupt("return");
            case 3:
              if (!_this9.completed) {
                _context10.next = 6;
                break;
              }
              _this9.showToastMessage(_this9.$t('liveroom.giftsendnotallowed'));
              return _context10.abrupt("return");
            case 6:
              if (!(_this9.anchorID == _this9.authentication.uid)) {
                _context10.next = 9;
                break;
              }
              _this9.showToastMessage('The operating error');
              return _context10.abrupt("return");
            case 9:
              _context10.prev = 9;
              _context10.next = 12;
              return _this9.VideoAPIService.sendGiftMessage(_this9.channelID, _this9.anchorID, giftID, _this9.authentication, count || 1, finanType);
            case 12:
              result = _context10.sent;
              if (!(result.status === '2')) {
                _context10.next = 20;
                break;
              }
              if (!(finanType == 103)) {
                _context10.next = 17;
                break;
              }
              _this9.$toast && _this9.$toast.center(_this9.$t('liveroom.toast-msg-notEnough-diamond'));
              return _context10.abrupt("return");
            case 17:
              util.KEWLSensorTrack({
                lmweb_clickText: '直播间充值',
                lmweb_tabName: 'pc'
              });
              _this9.rechargeHandler();
              return _context10.abrupt("return");
            case 20:
              if (_this9.$refs.toolbar && _this9.$refs.toolbar.authorization) {
                _this9.updateWalletSync(+(result.remainValue || 0));
              }
              if (_this9.$refs.toolbar && _this9.$refs.toolbar.giftwall) {
                _this9.$refs.toolbar.giftwall.updateExperienceSync(result);
              }
              util.KEWLSensorTrack({
                lmweb_clickText: 'pc-送礼',
                lmweb_giftId: giftID,
                lmweb_giftPriceLong: _this9.getGiftValue(giftID),
                lmweb_LiveUid: webLogin.getAuthentication().uid,
                lmweb_LiveVid: _this9.channelID
              });
              // 大数据送礼物上报
              if (window.localStorage) {
                util.ldcTrack({
                  act: 10,
                  giftid: giftID,
                  giftw: _this9.getGiftValue(giftID),
                  giftt: '101',
                  gifts: '1',
                  giftc: count || 1,
                  c: window.localStorage.getItem('ldcC'),
                  d: window.localStorage.getItem('ldcD')
                });
              }
              _context10.next = 29;
              break;
            case 26:
              _context10.prev = 26;
              _context10.t0 = _context10["catch"](9);
              _this9.tokenError(_context10.t0);
            case 29:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[9, 26]]);
      }))();
    },
    sendTextMessage: function sendTextMessage(content) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (webLogin.checkLogin()) {
                _context11.next = 3;
                break;
              }
              _this10.authenticateHandler();
              return _context11.abrupt("return");
            case 3:
              _context11.prev = 3;
              _context11.next = 6;
              return _this10.VideoAPIService.sendTextMessage(_this10.channelID, _this10.anchorID, content, _this10.authentication);
            case 6:
              util.KEWLSensorTrack({
                lmweb_clickText: '发送消息',
                lmweb_tabName: _this10.channelID
              });
              // 大数据发送消息上报
              if (window.localStorage) {
                util.ldcTrack({
                  act: 4,
                  msg: content,
                  c: window.localStorage.getItem('ldcC'),
                  d: window.localStorage.getItem('ldcD')
                });
              }
              _context11.next = 13;
              break;
            case 10:
              _context11.prev = 10;
              _context11.t0 = _context11["catch"](3);
              _this10.tokenError(_context11.t0);
            case 13:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[3, 10]]);
      }))();
    },
    tokenError: function tokenError(e) {
      if (e.status === 200 && e.data && e.data.status === '402') {
        // 重置Authentication
        webLogin.reset();
        this.$lmBus && this.$lmBus.$emit('Header-Login-Out-Handle');
        this.$emit('updateToken');
        this.authenticateHandler();
      }
    },
    updateToken: function updateToken() {
      // 重置Authentication
      webLogin.reset();
      this.$lmBus && this.$lmBus.$emit('Header-Login-Out-Handle');
      this.$emit('updateToken');
    },
    isAuthenticated: function isAuthenticated(authentication) {
      return !!authentication && !!authentication.uid;
    },
    isFollowAsync: function isFollowAsync() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var userinfo;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!(!_this11.anchorID || !webLogin.checkLogin())) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return", false);
            case 2:
              _context12.prev = 2;
              _context12.next = 5;
              return _this11.VideoAPIService.getUserInfo(_this11.anchorID, _this11.authentication || {});
            case 5:
              userinfo = _context12.sent.user.user_info;
              return _context12.abrupt("return", userinfo.is_relation === '50001' /* < 已关注 > */ || userinfo.is_relation === '50008');
            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12["catch"](2);
              _this11.tokenError(_context12.t0);
            case 12:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[2, 9]]);
      }))();
    },
    clearMessage: function clearMessage() {
      if (this.$refs.chatter) {
        this.$refs.chatter.clearMessage();
      }
      this.isDispatchInitMessage = false;
    },
    dispatchInitMessage: function dispatchInitMessage() {
      var _this12 = this;
      if (this.socket && !this.isComponentDestroyed && !this.isDispatchInitMessage) {
        this.isDispatchInitMessage = true;
        this.dispatchWelcomeMessage();
        this.dispatchFollowInvitationMessage();
        // / 延迟 1 秒发送，否则 socket 收不到消息。
        setTimeout(function () {
          _this12.dispatchEnterLiveroomMessage();
          try {
            //兼容拉去最近的im信息
            //this.socket.sendMessage('' , '', 70);
          } catch (e) {}
        }, 1000);
      }
    },
    dispatchWelcomeMessage: function dispatchWelcomeMessage() {
      this.dispatchCustomMessagePacketObject({
        content: this.$t('welcomeWords')
      }, 'DIY:welcome');
    },
    dispatchFollowInvitationMessage: function dispatchFollowInvitationMessage() {
      var _this13 = this;
      clearTimeout(this.followInvitationHandle);
      this.followInvitationHandle = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var isFollowed;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (webLogin.checkLogin()) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              _context13.next = 4;
              return _this13.isFollowAsync();
            case 4:
              isFollowed = _context13.sent;
              if (!isFollowed) {
                _this13.dispatchCustomMessagePacketObject({
                  content: _this13.$t('liveroom.boardcasterfollowinvitation'),
                  uid: _this13.anchorID,
                  name: _this13.anchorName,
                  level: _this13.anchorLevel
                }, 'DIY:boardcasterfollowinvitation');
              }
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })), this.followInvitationInterval);
    },
    dispatchEnterLiveroomMessage: function dispatchEnterLiveroomMessage() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!webLogin.checkLogin()) {
                _context14.next = 10;
                break;
              }
              _context14.prev = 1;
              _context14.next = 4;
              return _this14.VideoAPIService.enterCount(_this14.channelID, _this14.anchorID, _this14.authentication);
            case 4:
              if (_this14.$refs.topGifters) {
                _this14.$refs.topGifters.reload();
              }
              _context14.next = 10;
              break;
            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](1);
              _this14.tokenError(_context14.t0);
            case 10:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[1, 7]]);
      }))();
    },
    dispatchLeaveLiveroomMessage: function dispatchLeaveLiveroomMessage() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!webLogin.checkLogin()) {
                _context15.next = 9;
                break;
              }
              _context15.prev = 1;
              _context15.next = 4;
              return _this15.VideoAPIService.leaveCount(_this15.channelID, _this15.anchorID, _this15.authentication);
            case 4:
              _context15.next = 9;
              break;
            case 6:
              _context15.prev = 6;
              _context15.t0 = _context15["catch"](1);
              _this15.tokenError(_context15.t0);
            case 9:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[1, 6]]);
      }))();
    },
    dispatchCustomMessagePacketObject: function dispatchCustomMessagePacketObject(content, extend1) {
      switch (extend1) {
        case 'app:livevideostopmsgcontent':
          // 直播结束通知。
          this.completed = true;
          this.$emit('messageCallBack', {
            type: 'app:livevideostopmsgcontent',
            content: content
          });
          this.destroyComplete();
          break;
        // 主播踢人
        case 'app:forbidspeakmsgcontent':
          this.$emit('messageCallBack', {
            type: 'app:forbidspeakmsgcontent',
            content: content
          });
          break;
        case 'app:giftmsgcontent':
          content.giftcount = Math.max(+content.gradeCount, +content.send_num);
          this.$emit('messageCallBack', {
            type: 'app:giftmsgcontent',
            content: content
          });
          if (this.$refs.topGifters) {
            this.willBeReloadTopGifters();
          }
          break;
        default:
          this.$emit('messageCallBack', {
            type: extend1,
            content: content
          });
          break;
      }
      if (this.socket && !this.isComponentDestroyed) {
        if (this.$refs.chatter) {
          this.$refs.chatter.sendMessage({
            content: content,
            extend1: extend1
          });
        }
        if (this.$refs.player) {
          this.$refs.player.sendMessage({
            content: content,
            extend1: extend1
          });
        }
      }
    },
    showToastMessage: function showToastMessage(content) {
      this.toastMessage = content;
      console.log(this.toastMessage, '--this.toastMessage--');
      this.toastVisible = true;
    },
    hideToastMessage: function hideToastMessage() {
      this.toastVisible = false;
    },
    getGiftList: function getGiftList(giftTabs) {
      var output = [];
      // eslint-disable-next-line no-restricted-syntax
      var _iterator3 = _createForOfIteratorHelper(giftTabs),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tab = _step3.value;
          // eslint-disable-next-line no-restricted-syntax
          var _iterator4 = _createForOfIteratorHelper(tab.giftList),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var gift = _step4.value;
              output.push(gift);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return output;
    },
    getGiftByIds: function getGiftByIds(ids) {
      var output = [];
      // eslint-disable-next-line no-restricted-syntax
      var _iterator5 = _createForOfIteratorHelper(ids),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var id = _step5.value;
          // eslint-disable-next-line no-restricted-syntax
          var _iterator6 = _createForOfIteratorHelper(this.giftList),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var gift = _step6.value;
              if (gift.id === id) {
                output.push(gift);
                break;
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return output;
    },
    getGiftValue: function getGiftValue(id) {
      var gifts = this.getGiftByIds([id]);
      return gifts && gifts.length ? +gifts[0].gold : 0;
    },
    authenticateHandler: function authenticateHandler() {
      this.$emit('authenticate');
    },
    rechargeHandler: function rechargeHandler() {
      if (!webLogin.checkLogin()) {
        this.authenticateHandler();
        return;
      }
      this.$emit('recharge');
    },
    openGiftWallHandler: function openGiftWallHandler() {
      this.isOpenGiftWall = !this.isOpenGiftWall;
    },
    initTooltips: function initTooltips() {
      this.clearTooltips();
      this.showFollowTooltipDelayHandle = setTimeout(this.openFollowTooltip, this.showFollowTooltipDelay);
      this.showGiftWallTooltipDelayHandle = setTimeout(this.openGiftWallTooltip, this.showGiftWallTooltipDelay);
      this.showShareTooltipDelayHandle = setTimeout(this.openShareTooltip, this.showShareTooltipDelay);
    },
    initTimeInterval: function initTimeInterval() {
      this.showShareTimeTooltipDelayHandle = setInterval(this.openShareTooltip, 30000);
    },
    clearTooltips: function clearTooltips() {
      clearTimeout(this.showFollowTooltipDelayHandle);
      clearTimeout(this.showGiftWallTooltipDelayHandle);
      clearTimeout(this.showShareTooltipDelayHandle);
      clearInterval(this.showShareTimeTooltipDelayHandle);
      this.showFollowTooltipVisible = false;
      this.showGiftWallTooltipVisible = false;
      this.showFollowModalVisible = false;
      this.showFollowModalTimes = 0;
      this.showShareTooltipVisible = false;
    },
    openFollowModal: function openFollowModal() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var watchTime, isFollowed;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (webLogin.checkLogin()) {
                _context16.next = 2;
                break;
              }
              return _context16.abrupt("return", true);
            case 2:
              watchTime = Date.now();
              watchTime -= _this16.channelInitTimestamp;

              // / 观看时间过短。
              if (!(watchTime <= _this16.showFollowModalAfter)) {
                _context16.next = 6;
                break;
              }
              return _context16.abrupt("return", true);
            case 6:
              _context16.next = 8;
              return _this16.isFollowAsync();
            case 8:
              isFollowed = _context16.sent;
              if (!isFollowed) {
                _context16.next = 11;
                break;
              }
              return _context16.abrupt("return", true);
            case 11:
              return _context16.abrupt("return", _this16.createFollowModal());
            case 12:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    openFollowTooltip: function openFollowTooltip() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var isFollowed;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return _this17.isFollowAsync();
            case 2:
              isFollowed = _context17.sent;
              if (!isFollowed) {
                _context17.next = 5;
                break;
              }
              return _context17.abrupt("return");
            case 5:
              return _context17.abrupt("return", _this17.createFollowTooltip());
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    openGiftWallTooltip: function openGiftWallTooltip() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", _this18.createGiftWallTooltip());
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    openShareTooltip: function openShareTooltip() {
      return this.createShareTooltip();
    },
    createFollowTooltip: function createFollowTooltip() {
      var _this19 = this;
      var storgeKey = 'LIVEROOM_TOOLTIP_FOLLOW_STATE_V2';
      var storgeValue = null || localStorage.getItem(storgeKey);
      var currentTimestamp = Date.now();
      var currentState = storgeValue ? JSON.parse(storgeValue) : {
        timestamp: currentTimestamp,
        counter: 0
      };

      // / 关注引导每天显示 3 次，如果本地保存的状态已经过期，则需要进行重置。
      if (storgeValue && !util.isSameDay(currentState.timestamp, currentTimestamp)) {
        currentState.timestamp = currentTimestamp;
        currentState.counter = 0;
      }

      // / 超过最大显示次数。
      if (currentState.counter >= this.showFollowTooltipMaxTimesPerDay) {
        return;
      }

      // / 写入当前状态。
      // eslint-disable-next-line no-plusplus
      ++currentState.counter;
      localStorage.setItem(storgeKey, JSON.stringify(currentState));

      // / 显示 tooltip。
      this.showFollowTooltipVisible = true;

      // / 点击任意位置关闭。
      var _callback = function callback() {
        document.removeEventListener('click', _callback, true);
        _this19.showFollowTooltipVisible = false;
      };
      document.addEventListener('click', _callback, true);
    },
    createShareTooltip: function createShareTooltip() {
      var _this20 = this;
      if (this.showShareTooltipVisible) {
        return;
      }
      // const storgeKey = 'LIVEROOM_TOOLTIP_SHARE_STATE_V2';
      // const storgeValue = null || localStorage.getItem(storgeKey);
      // const currentTimestamp = Date.now();
      // const currentState = storgeValue ? JSON.parse(storgeValue) : { timestamp: currentTimestamp, counter: 0 };
      // // / 关注引导每天显示 3 次，如果本地保存的状态已经过期，则需要进行重置。
      // if (storgeValue && !util.isSameDay(currentState.timestamp, currentTimestamp)) {
      //     currentState.timestamp = currentTimestamp;
      //     currentState.counter = 0;
      // }
      // // / 超过最大显示次数。
      // if (currentState.counter >= this.showShareMaxTimesPerDay) {
      //     return true;
      // }
      // / 写入当前状态。
      // eslint-disable-next-line no-plusplus
      // ++currentState.counter;
      // localStorage.setItem(storgeKey, JSON.stringify(currentState));

      // / 显示 tooltip。
      this.showShareTooltipVisible = true;

      // / 点击任意位置关闭。
      var _callback2 = function callback() {
        document.removeEventListener('click', _callback2, true);
        _this20.showShareTooltipVisible = false;
      };
      document.addEventListener('click', _callback2, true);
    },
    createGiftWallTooltip: function createGiftWallTooltip() {
      var _this21 = this;
      var storgeKey = 'LIVEROOM_TOOLTIP_GIFTWALL_STATE_V2';
      var storgeValue = null || localStorage.getItem(storgeKey);
      var currentTimestamp = Date.now();
      var currentState = storgeValue ? JSON.parse(storgeValue) : {
        timestamp: currentTimestamp,
        counter: 0
      };

      // / 超过最大显示次数。
      if (currentState.counter >= this.showGiftWallTooltipMaxTimes) {
        return;
      }

      // / 写入当前状态。
      // eslint-disable-next-line no-plusplus
      ++currentState.counter;
      localStorage.setItem(storgeKey, JSON.stringify(currentState));

      // / 显示 tooltip。
      this.showGiftWallTooltipVisible = true;

      // / 点击任意位置关闭。
      var _callback3 = function callback() {
        document.removeEventListener('click', _callback3, true);
        _this21.showGiftWallTooltipVisible = false;
      };
      document.addEventListener('click', _callback3, true);
    },
    createFollowModal: function createFollowModal() {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var storgeKey, storgeValue, currentTimestamp, currentState;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              storgeKey = 'LIVEROOM_MODAL_FOLLOW_STATE_V2';
              storgeValue = null || localStorage.getItem(storgeKey);
              currentTimestamp = Date.now();
              currentState = storgeValue ? JSON.parse(storgeValue) : {
                timestamp: currentTimestamp,
                counter: 0
              }; // / 关注引导每天显示 3 次，如果本地保存的状态已经过期，则需要进行重置。
              if (storgeValue && !util.isSameDay(currentState.timestamp, currentTimestamp)) {
                currentState.timestamp = currentTimestamp;
                currentState.counter = 0;
              }
              // / 超过最大显示次数。
              if (!(currentState.counter >= _this22.showFollowModalMaxTimesPerDay)) {
                _context20.next = 7;
                break;
              }
              return _context20.abrupt("return", true);
            case 7:
              // / 写入当前状态。
              // eslint-disable-next-line no-plusplus
              ++currentState.counter;
              localStorage.setItem(storgeKey, JSON.stringify(currentState));
              return _context20.abrupt("return", new Promise(function (resolve) {
                // / 显示 modal。
                _this22.showFollowModalVisible = true;
                // / 关闭。

                var _acceptCallback = /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                      while (1) switch (_context19.prev = _context19.next) {
                        case 0:
                          _this22.$off('acceptFollowModal', _acceptCallback);
                          // eslint-disable-next-line no-use-before-define
                          _this22.$off('cancelFollowModal', _cancelCallback);
                          _this22.showFollowModalVisible = false;
                          _context19.next = 5;
                          return _this22.subscribeHandler(_this22.anchorID, false, 5);
                        case 5:
                          resolve(true);
                        case 6:
                        case "end":
                          return _context19.stop();
                      }
                    }, _callee19);
                  }));
                  return function acceptCallback() {
                    return _ref3.apply(this, arguments);
                  };
                }();
                var _cancelCallback = function cancelCallback() {
                  _this22.$off('acceptFollowModal', _acceptCallback);
                  _this22.$off('cancelFollowModal', _cancelCallback);
                  _this22.showFollowModalVisible = false;
                  resolve(true);
                };
                _this22.$on('acceptFollowModal', _acceptCallback);
                _this22.$on('cancelFollowModal', _cancelCallback);
              }));
            case 10:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    subscribeHandler: function subscribeHandler(targetID, isSubscribing) {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var followInfo;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (webLogin.checkLogin()) {
                _context21.next = 3;
                break;
              }
              _this23.authenticateHandler();
              return _context21.abrupt("return");
            case 3:
              util.loadingFunc({
                time: 2000
              });
              _context21.prev = 4;
              if (!isSubscribing) {
                _context21.next = 12;
                break;
              }
              _context21.next = 8;
              return _this23.VideoAPIService.unsubscribe(targetID, _this23.authentication || {});
            case 8:
              util.KEWLSensorTrack({
                lmweb_clickText: 'unfollow',
                lmweb_tabName: targetID
              });
              // 大数据取消关注上报
              if (window.localStorage) {
                util.ldcTrack({
                  act: 7,
                  fuid: targetID,
                  c: window.localStorage.getItem('ldcC'),
                  d: window.localStorage.getItem('ldcD')
                });
              }
              _context21.next = 28;
              break;
            case 12:
              followInfo = null;
              if (!(_this23.anchorID === targetID)) {
                _context21.next = 19;
                break;
              }
              _context21.next = 16;
              return _this23.VideoAPIService.subscribe(targetID, _this23.authentication || {}, _this23.channelID);
            case 16:
              followInfo = _context21.sent;
              _context21.next = 22;
              break;
            case 19:
              _context21.next = 21;
              return _this23.VideoAPIService.subscribe(targetID, _this23.authentication || {});
            case 21:
              followInfo = _context21.sent;
            case 22:
              if (!(followInfo && followInfo.data && followInfo.data.follow_status == '5')) {
                _context21.next = 25;
                break;
              }
              _this23.showToastMessage(_this23.$t('liveroom.followBlackTip'));
              return _context21.abrupt("return");
            case 25:
              util.KEWLSensorTrack({
                lmweb_clickText: 'follow',
                lmweb_tabName: targetID
              });
              // 大数据关注上报
              if (window.localStorage) {
                util.ldcTrack({
                  act: 6,
                  fuid: targetID,
                  c: window.localStorage.getItem('ldcC'),
                  d: window.localStorage.getItem('ldcD')
                });
              }
              _this23.logFollow(targetID);
            case 28:
              if (_this23.$refs.profile && _this23.$refs.profile.anchorID === targetID) {
                _this23.$refs.profile.updateAnchorInfo();
              }
              if (_this23.$refs.personalcard && _this23.$refs.personalcard.targetUid === targetID) {
                _this23.$refs.personalcard.relationState = !_this23.$refs.personalcard.relationState;
              }
              _context21.next = 38;
              break;
            case 32:
              _context21.prev = 32;
              _context21.t0 = _context21["catch"](4);
              if (!(_context21.t0 && _context21.t0.data && _context21.t0.data.data && _context21.t0.data.data.follow_status == '5')) {
                _context21.next = 37;
                break;
              }
              _this23.showToastMessage(_this23.$t('liveroom.followBlackTip'));
              return _context21.abrupt("return");
            case 37:
              _this23.tokenError(_context21.t0);
            case 38:
            case "end":
              return _context21.stop();
          }
        }, _callee21, null, [[4, 32]]);
      }))();
    },
    cancelFollowModal: function cancelFollowModal() {
      this.$emit('cancelFollowModal');
    },
    acceptFollowModal: function acceptFollowModal() {
      this.$emit('acceptFollowModal');
    },
    openCardWithGlobalPosition: function openCardWithGlobalPosition(uid, source, rect) {
      var relativeRect = this.$refs.liveroomContainer.getBoundingClientRect();
      rect.x -= relativeRect.left;
      rect.y -= relativeRect.top;
      this.opencard(uid, source, rect);
    },
    opencard: function opencard(targetId, source, pos) {
      // // 1用户 2视频, 3:短视频 4 速配 5ins 举报
      if (targetId && source) {
        this.isShowCard = true;
        this.cardTargetUid = targetId;
        this.cardType = source;
        this.cardTop = "".concat(pos.y);
        this.cardLeft = "".concat(pos.x);
      }
    },
    closecard: function closecard() {
      this.isShowCard = false;
    },
    logFollow: function logFollow(targetID) {
      var _this24 = this;
      this.VideoAPIService.getProfile(targetID, this.authentication || {}).then(function (data) {
        if (data && data.user_info) {
          var uinfo = data.user_info;
          _this24.$emit('logFollow', {
            followeeIsFollowing: uinfo.is_relation === '50008',
            followeeGender: uinfo.sex,
            // sex=0 女 sex=1 男 sex=-1 未公开
            followeeAge: uinfo.age,
            source: 'live'
          });
        }
      }).catch(function (e) {
        _this24.tokenError(e);
      });
    },
    logStreamView: function logStreamView(targetID, vid) {
      var _this25 = this;
      if (!webLogin.getAuthentication()) {
        return;
      }
      this.VideoAPIService.getProfile(targetID, this.authentication || {}).then(function (data) {
        if (data && data.user_info) {
          var uinfo = data.user_info;
          _this25.$emit('logStreamView', {
            streamerVideoId: vid,
            streamerNickname: uinfo.nickname,
            streamerGender: uinfo.sex,
            // sex=0 女 sex=1 男 sex=-1 未公开
            streamerAge: uinfo.age
          });
        }
      }).catch(function (e) {
        _this25.tokenError(e);
      });
    },
    mediaEventHandler: function mediaEventHandler(evt) {
      if (evt.type === 'loadedmetadata') {
        this.$emit('metadata', this.$refs.player.getVideoWidth(), this.$refs.player.getVideoHeight());
      }
      console.log(evt.type, 'mediaEventHandler');
      if (evt.type === 'playing') {
        this.$lmBus && this.$lmBus.$emit('Live-Play-Success-Handle');
      }
    },
    playerEventHandler: function playerEventHandler(evt) {
      if (evt.type === 'refresh') {
        this.updateChannel();
      }
      this.$emit(evt.type);
    },
    willBeReloadTopGifters: function willBeReloadTopGifters() {
      var _this26 = this;
      if (this.topGidtersReloadTimestamp === 0) {
        clearTimeout(this.topGiftersReloadHandle);
        this.topGidtersReloadTimestamp = 1;
        this.topGiftersReloadHandle = setTimeout(function () {
          _this26.topGidtersReloadTimestamp = 0;
          if (_this26.$refs.topGifters) {
            _this26.$refs.topGifters.reload();
          }
        }, this.topGiftersReloadInterval);
      }
    },
    userWillBeLeave: function userWillBeLeave() {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!(_this27.showFollowModalTimes === 0)) {
                _context22.next = 3;
                break;
              }
              // eslint-disable-next-line no-plusplus
              ++_this27.showFollowModalTimes;
              return _context22.abrupt("return", _this27.openFollowModal());
            case 3:
              return _context22.abrupt("return", true);
            case 4:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    }
  }, _applyDecoratedDescriptor(_obj, "sendGiftMessage", [_dec], Object.getOwnPropertyDescriptor(_obj, "sendGiftMessage"), _obj), _applyDecoratedDescriptor(_obj, "sendTextMessage", [_dec2], Object.getOwnPropertyDescriptor(_obj, "sendTextMessage"), _obj), _applyDecoratedDescriptor(_obj, "subscribeHandler", [_dec3], Object.getOwnPropertyDescriptor(_obj, "subscribeHandler"), _obj), _obj),
  watch: {
    channelDependencies: function channelDependencies() {
      this.updateChannel();
    },
    minimum: function minimum(value) {
      this.$refs.player.swapController(value);
    },
    wallet: function wallet() {
      this.updateWalletSync(this.wallet.gold);
    }
  }
};